import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs';
import { RequestPropertyDatasource } from '../../../core/datasource/request-property-datasource';
import { IRequestProperty } from '../../../core/interfaces/request-property.interface';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class IndexComponent implements OnInit {

  public dataSource: RequestPropertyDatasource | null;
  public properties: BehaviorSubject<IRequestProperty[]> = new BehaviorSubject<IRequestProperty[]>([]);

  public displayedColumns = ['property', 'description'];

  constructor(private title: Title) {
    this.title.setTitle("AI - Intent | Dillo")
  }

  ngOnInit() {
    this.dataSource = new RequestPropertyDatasource(this.properties);

    this.properties.next(this.getIntents());
  }



  getIntents(): IRequestProperty[] {
    return [
      { property: 'Default welcome intent', type: ' ', value: '', description: 'It represents the welcome intent. It can be edited and deleted.' },
      { property: 'None', type: '', value: '', description: 'The scope of this intent is to determine what are phrases unrelated to the bot domain. <b>It can not be renamed or deleted</b>.' }
    ]
  }

}
